import React from 'react'

const patientExceptions = {
  'professional_unavailability': {
    tooltipContent: <>O profissional não estará disponível. <br /> Excepcionalmente nesta semana, você <br/> deve agendar em </>
  },
  'cancelled_by_patient': {
    tooltipContent: <>Você cancelou a reserva deste dia.</>
  },
  'cancelled_by_professional': {
    tooltipContent: <>O psicólogo cancelou a reserva deste dia.</>
  },
  'rescheduled_by_professional': {
    tooltipContent: <>O profissional remarcou este dia. <br /> Excepcionalmente nesta semana, você <br/> deve agendar em </>
  },
  'rescheduled_by_patient': {
    tooltipContent: <>Você remarcou este dia para </>
  }
}

const adminExceptions = {
  ...patientExceptions,
  'cancelled_by_patient': {
    tooltipContent: <>O Paciente cancelou a reserva deste dia.</>
  }
}

export {
  patientExceptions,
  adminExceptions
}